import { useState } from "react";
import Button from "react-bootstrap/Button";

import Reports from "./Reports";
import BookModalLink from "../BookModalLink";
import QuestionModalLink from "../QuestionModalLink";
import TextInput from "../TextInput";
import Translated from "../Translated";
import { useAddBookReference } from "../../../api-new";

const LiteralQuestionAdmin = ({
  updateId,
  lang,
  question,
  category,
  refetchQuestions,
}) => {
  const [bookReference, setBookReference] = useState("");
  const bookReferenceMutation = useAddBookReference();

  const saveReference = () => {
    bookReferenceMutation.mutate(
      {
        questionType: "literal",
        questionId: question.id,
        category,
        referenceId: bookReference,
      },
      {
        onSuccess: () => {
          refetchQuestions();
        },
      }
    );
  };

  const renderBookContent = () => {
    if (question.bookReferenceIds.length === 0) {
      return (
        <div>
          <TextInput
            listener={(value) => setBookReference(value)}
            value={bookReference}
            placeholder="book reference id"
          />
          <Button disabled={bookReference.length < 1} onClick={saveReference}>
            <Translated translationKey="save" />
          </Button>
          {bookReferenceMutation.isError && (
            <span>
              <Translated
                translationKey={bookReferenceMutation.error.message}
              />
            </span>
          )}
        </div>
      );
    }

    return question.bookReferenceIds.map((refId) => (
      <BookModalLink lang={lang} contentId={refId} showId key={refId} />
    ));
  };

  const renderQuestionEdit = (questionId) => {
    return <QuestionModalLink questionId={questionId} refetch={refetchQuestions}/>
  }

  const renderReports = () => {
    const reports = question.reports;
    const hasReports = question.reports && question.reports.length > 0;
    return hasReports ? <Reports reports={reports} questionType={'literal'} questionId={question.id} onCloseAfterHandle={refetchQuestions} /> : null;
  };

  const renderExplanation = () => {
    if (!question.explanation) {
      return null;
    }
    return (
      <div>
        <strong><Translated translationKey="explanation" />:</strong>&nbsp;
        <span className="test-result-literal-answer-text">{question.explanation}</span>
      </div>
    );
  }

  const renderTopic = () => {
    if (!question.topic) {
      return null;
    }
    return (
      <div>
        <strong><Translated translationKey="topic" />:</strong>&nbsp;
        <span className="test-result-literal-answer-text">{question.topic}</span>
      </div>
    );
  }

  const renderEnabledLicenseCategories = () => {
    if (question.enabledLicenseCategories.length === 0) {
      return null;
    }
    const enabledLicenseCategories = question.enabledLicenseCategories.join(', ');
    return (
      <div>
        <strong><Translated translationKey="license_classes" />:</strong>&nbsp;
        <span className="test-result-literal-answer-text">{enabledLicenseCategories}</span>
      </div>
    );
  }

  const renderActiveStatus = () => {
    const translationKey = question.isActive ? 'active' : 'inactive';
    return (
      <div>
        <strong><Translated translationKey="status" />:</strong>&nbsp;
        <span className="test-result-literal-answer-text">
          <Translated translationKey={translationKey} />
        </span>
      </div>
    );
  }

  const renderSourceReferences = () => {
    return (
      <div>
        <strong>{question.source}</strong> {question.updateId}
      </div>
    );
  }

  if (!question) {
    return null;
  }

  return (
    <div className="test-result-literal-wrapper">
      <div className="mb-3">
        <h5>
          {question.id}. {question.question}
        </h5>
        {question.needsReview && <div className="badge bg-danger"><Translated translationKey={'review_indicator'} /></div>}
        {question.needsLocalization && <div className="badge bg-warning"><Translated translationKey={'missing_localization_indicator'} /></div>}
        
        {question.imageUrl && (
          <img src={question.imageUrl} className="practise-literal-image" />
        )}
        <div className={question.correctAnswer === "a" ? "underlined" : ""}>
          {question.options.a}
        </div>
        <div className={question.correctAnswer === "b" ? "underlined" : ""}>
          {question.options.b}
        </div>
        <div className={question.correctAnswer === "c" ? "underlined" : ""}>
          {question.options.c}
        </div>
      </div>
      {renderExplanation()}
      {renderEnabledLicenseCategories()}
      {renderTopic()}
      {renderActiveStatus()}
      {renderSourceReferences()}
      {renderBookContent()}
      {renderQuestionEdit(question.id)}
      {renderReports()}
    </div>
  );
};

export default LiteralQuestionAdmin;
